import React from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Radio, Button, Typography} from 'antd';

const AntRadio = ({ options, deleteFn, value, onChange, isButton }) => {
  return (
    <Radio.Group onChange={onChange} value={value} style={{ minWidth: '100%' }}>
      {options.map((option, index) => (
        <div
          key={index}
          style={{
            display: 'flex',
            alignItems: 'center',
            border: isButton ? '1px solid #e8e8e8' : '',
            borderRadius: isButton ? '4px' : '',
            padding: isButton ? '2px' : '',
            backgroundColor: value === option.value && isButton ? '#f0f0f0' : 'white',
            marginBottom: '10px',
          }}
        >
          <Radio value={option.value} style={{ width: '100%' }}>
            <Typography
              style={{
                fontSize: value === option.value ? '16px' : '14px',
                color: value === option.value ? 'blue' : 'black',
              }}
            >
              {option.label}
            </Typography>
          </Radio>

          {deleteFn && (
            <Button
              type="text"
              shape="circle"
              icon={<CloseCircleOutlined style={{ color: '#ff9999' }} />}
              onClick={() => deleteFn(index)}
            />
          )}
        </div>
      ))}
    </Radio.Group>
  );
};

export default AntRadio;
